import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "p-m-0" }, "Expiration d'abonnement", -1)
const _hoisted_2 = { style: {"max-width":"400px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_ctx.visible)
    ? (_openBlock(), _createBlock(_component_Dialog, {
        key: 0,
        class: "p-mx-2",
        visible: _ctx.visible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
        modal: ""
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "p-button-outlined",
            label: _ctx.$t('activity.renewSubscription'),
            onClick: _ctx.onRenewClick,
            style: {"width":"100%"}
          }, null, 8, ["label", "onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("activity.expirationMessage")), 1)
        ]),
        _: 1
      }, 8, ["visible"]))
    : _createCommentVNode("", true)
}